module.exports = __webpack_public_path__ + "static/media/RoomService_Meal1_Category2_Item1.9f14a0f1.png";